import {
  GetProviderDetailsActionTypes,
  GET_PROVIDER_LOGIN_DETAILS_FAIL,
  GET_PROVIDER_LOGIN_DETAILS_LOADING,
  GET_PROVIDER_LOGIN_DETAILS_SUCCESS,
  GetProviderLoginDetailsState,
  GET_PROVIDER_LOGIN_DETAILS_API_MSG,
  GET_PROVIDER_LOGIN_DETAILS_API_RES,
} from "./ActionTypes";
import { GetProviderDetailsRes } from "./Model";

const initialStateUpdatePosts: GetProviderLoginDetailsState = {
  loading: false,
  getProviderLoginDetailsRes: {} as GetProviderDetailsRes,
  errorMsg: "",
  status: 0,
};
export const getProviderLoginDetailsReducer = (
  state = initialStateUpdatePosts,
  action: GetProviderDetailsActionTypes
): GetProviderLoginDetailsState => {
  switch (action.type) {
    case GET_PROVIDER_LOGIN_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_PROVIDER_LOGIN_DETAILS_SUCCESS:
      return {
        ...state,
        getProviderLoginDetailsRes: action.payload,
      };
    case GET_PROVIDER_LOGIN_DETAILS_FAIL:
      return {
        ...state,
        getProviderLoginDetailsRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_PROVIDER_LOGIN_DETAILS_API_MSG:
      return {
        ...state,
        getProviderLoginDetailsRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_PROVIDER_LOGIN_DETAILS_API_RES:
      return {
        ...state,
        getProviderLoginDetailsRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
